import dayjs from 'dayjs';

export const today = dayjs();

export const getTimeStamp = (format: string) => {
  return today.format(format);
};
